export default {
	methods: {
		/*collectFormData(data){
			return Object.keys(data).reduce( (acc, prop) =>{
				console.log('---------------------');
				console.log(data[prop]);
			 	console.log(Array.isArray(data[prop]));

				 /!*if (Array.isArray(data[prop])){
					 data[prop].forEach(item=>{
						 return acc.append(`${prop}[]`, item)
					 });
					 return acc;
					 // return data[prop] ? (acc.append(prop, Array.isArray(data[prop]) ? JSON.stringify(data[prop]) : data[prop]) || acc) : acc
				 } else {
					 return data[prop] ? (acc.append(prop, data[prop]) || acc) : acc
				 }*!/
				// console.log(data[prop].constructor.name === 'Array' );
				return data[prop] ? (acc.append(prop, Array.isArray(data[prop]) ? JSON.stringify(data[prop]) : data[prop]) || acc) : acc
			},(new FormData()))

		},*/
		_buildFormData(formData, data, parentKey) {
			if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
				Object.keys(data).forEach(key => {
					this._buildFormData(formData, data[key], parentKey ? `${parentKey}` : key);
				});
			} else {
				const value = data == null ? '' : data;

				formData.append(parentKey, value);
			}
		},
		collectFormData(data) {
			const formData = new FormData();

			this._buildFormData(formData, data);

			return formData;
		},
	}
};
